var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #00b43d;\r\n      }\r\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.2 0 5 0 1.6 2.5 .3 6.5 1.6 10.5 5 13 9.2 13 12.6 10.5 13.9 6.5 12.6 2.5 9.2 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/standard.4b335e44bd62a1192874b4e5e31bbe33.svg";
export { ForwardRef as ReactComponent };